// extracted by mini-css-extract-plugin
export default {"userForm":"Form_userForm__c2106","formHeader":"Form_formHeader__-LovN","welcomePage":"Form_welcomePage__VHLSq","formText":"Form_formText__xgtQk"};